import { CREATE_COMPLAINT_FAILED, CREATE_COMPLAINT_SUCCESS } from '../actions/actiontypes'

const INIT_STATE = {
	completed:false,
}

export default function(state = INIT_STATE, action) {
	switch(action.type){
		case CREATE_COMPLAINT_FAILED:{
			return {...state, data:action.payload};
		}
		case CREATE_COMPLAINT_SUCCESS:{
			return {...state, data:action.payload};
		}
		default:
			return state;
	}
}